import { useFormik } from "formik";
import React, { useEffect } from "react";
import toast from "react-hot-toast";
import { Col, Container, Form, FormGroup, Label, Row } from "reactstrap";
import { Button, InputField } from "src/components";
import { setFromErrors } from "src/helpers";
import { useInsDutiesEntryMutation } from "src/rtk/features/instituteAndDepartmentRegistration/instituteAndDepartmentRegistrationApi";
import * as Yup from 'yup';

interface TrainersAcademicInvolvementProps {
    departmentId?: string;
    recordOfTrainersAcademicInvolvementToEdit?: InsDutiesList;
    setModalShow?: any;
}

const initialValues: InsDutiesEntry = {
    ins_training_id: '',
    form_b_department_id: '',
    duties: '',
    frequency_or_week: '',
    unit: '',
    type: '',
};

const TrainersAcademicInvolvementModal = (props: TrainersAcademicInvolvementProps) => {
    const { departmentId, recordOfTrainersAcademicInvolvementToEdit, setModalShow } = props;

    const [trainersAcademicInvolvementEntry, { data: trainersAcademicInvolvementEntryData, isSuccess: isTrainersAcademicInvolvementEntryDataSuccess, isLoading: isTrainersAcademicInvolvementEntryDataLoading, isError: isTrainersAcademicInvolvementEntryDataError, error: trainersAcademicInvolvementEntryDataError }] =
        useInsDutiesEntryMutation();

    const err: CustomError = trainersAcademicInvolvementEntryDataError as CustomError;

    const formik = useFormik({
        initialValues,
        validationSchema: Yup.object({}),

        onSubmit: (values: InsDutiesEntry) => {
            console.log(values);
            values.form_b_department_id = departmentId;
            values.type = 'academic_involvement';
            values.unit = 'month';
            trainersAcademicInvolvementEntry(values);
        },
    });

    const {
        handleSubmit,
        getFieldProps,
        values,
        handleChange,
        handleBlur,
        touched,
        errors,
        resetForm,
        setValues,
        setErrors,
        setFieldValue,
    } = formik;

    const handleFormReset = () => {
        resetForm();
    };

    useEffect(() => {
        if (recordOfTrainersAcademicInvolvementToEdit?.id) {
            setValues({
                ins_training_id: recordOfTrainersAcademicInvolvementToEdit?.id,
                form_b_department_id: recordOfTrainersAcademicInvolvementToEdit?.form_b_department_id,
                duties: recordOfTrainersAcademicInvolvementToEdit?.duties,
                frequency_or_week: recordOfTrainersAcademicInvolvementToEdit?.frequency_or_week,
                unit: recordOfTrainersAcademicInvolvementToEdit?.unit,
                type: recordOfTrainersAcademicInvolvementToEdit?.type,
            });
        }
    }, []);

    useEffect(() => {
        if (isTrainersAcademicInvolvementEntryDataSuccess) {
            handleFormReset();
            toast.success('Trainer\'s academic involvement record saved successfully');
            setModalShow(false);
        }
        if (isTrainersAcademicInvolvementEntryDataError) {
            Object.entries(err?.data).forEach((entry: any) => {
                entry[1]?.forEach((message: any) => {
                    toast.error(message);
                });
            });
            setFromErrors(err.data, setErrors);
        }
    }, [isTrainersAcademicInvolvementEntryDataSuccess, isTrainersAcademicInvolvementEntryDataError]);

    return (
        <React.Fragment>
            <Container fluid>
                <Row>
                    <Col lg={12}>
                        <Form
                            autoComplete="off"
                            className="custom-form"
                            onSubmit={(e) => {
                                e.preventDefault();
                                handleSubmit();
                            }}
                            onReset={(e) => {
                                e.preventDefault();
                                handleFormReset();
                            }}
                        >
                            <Row>
                                <Col sm={12} md={6}>
                                    <FormGroup className="mb-3">
                                        <Label for="duties">Duties</Label>
                                        <InputField
                                            type="select"
                                            options={[
                                                { label: 'Lecture', value: 'Lecture' },
                                                { label: 'Tutorial', value: 'Tutorial' },
                                                { label: 'Group Discussion', value: 'Group Discussion' },
                                                { label: 'Bed side teaching', value: 'Bed side teaching' },
                                                { label: 'Teaching at OT', value: 'Teaching at OT' },
                                                { label: 'Journals Club', value: 'Journals Club' },
                                                { label: 'Seminar', value: 'Seminar' }
                                            ]}
                                            placeholder=""
                                            {...getFieldProps('duties')}
                                        />
                                    </FormGroup>
                                </Col>

                                <Col sm={12} md={6}>
                                    <FormGroup className="mb-3">
                                        <Label for="frequency_or_week">Frequency per month</Label>
                                        <InputField
                                            type="text"
                                            placeholder=""
                                            {...getFieldProps('frequency_or_week')}
                                        />
                                    </FormGroup>
                                </Col>

                                <Col sm={12} className="mt-3">
                                    <FormGroup className="mb-3 text-center">
                                        <Button
                                            type="reset"
                                            text="Reset"
                                            className="btn btn-warning me-2"
                                        ></Button>
                                        <Button
                                            type="submit"
                                            text="Save"
                                            className="btn btn-success me-2"
                                            disabled={isTrainersAcademicInvolvementEntryDataLoading}
                                        ></Button>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </Container>
        </React.Fragment>
    );
};

export default TrainersAcademicInvolvementModal;